import type { LoginResponse } from '@proerp/shared';

/**
 * Die Schritte der Portal-Anmeldung (ADR 0085, Ablauf wie intern nach ADR 0034).
 * TOTP und Passkey sind gleichrangig: Beim allerersten Login wählt der Partner
 * frei ('setup-choice'), hat er beides eingerichtet, wählt er je Anmeldung
 * ('second-factor-choice').
 */
export type LoginStep =
  | 'credentials'
  | 'setup-choice'
  | 'totp-setup'
  | 'totp-verify'
  | 'passkey-setup'
  | 'second-factor-choice'
  | 'passkey-verify';

/**
 * Welcher Schritt folgt auf die Passwort-Eingabe? Als reine Funktion, damit die
 * Verzweigung ohne DOM prüfbar ist — sie entscheidet, ob jemand einen zweiten
 * Faktor einrichtet oder nur bestätigt, und darf nicht stillschweigend kippen.
 */
export function nextStepAfterCredentials(status: LoginResponse['status']): LoginStep {
  switch (status) {
    case 'SETUP_REQUIRED':
      return 'setup-choice';
    case 'PASSKEY_REQUIRED':
      return 'passkey-verify';
    case 'SECOND_FACTOR_CHOICE':
      return 'second-factor-choice';
    case 'TOTP_REQUIRED':
    default:
      return 'totp-verify';
  }
}

/** Überschrift und Erklärtext je Schritt. */
export const STEP_META: Record<LoginStep, { title: string; subtitle: string }> = {
  credentials: {
    title: 'Partnerportal',
    subtitle: 'Bitte melde dich mit deinen Zugangsdaten an.',
  },
  'setup-choice': {
    title: 'Zweiten Faktor einrichten',
    subtitle: 'Wähle, wie du dich künftig zusätzlich zum Passwort bestätigst.',
  },
  'totp-setup': {
    title: 'Authenticator-App einrichten',
    subtitle: 'Scanne den Code mit deiner Authenticator-App.',
  },
  'totp-verify': {
    title: 'Zwei-Faktor-Bestätigung',
    subtitle: 'Gib den 6-stelligen Code aus deiner App ein.',
  },
  'passkey-setup': {
    title: 'Passkey einrichten',
    subtitle: 'Folge den Anweisungen deines Geräts (Face ID, Touch ID, PIN …).',
  },
  'second-factor-choice': {
    title: 'Zweiten Faktor bestätigen',
    subtitle: 'Wähle Authenticator-Code oder Passkey.',
  },
  'passkey-verify': {
    title: 'Mit Passkey anmelden',
    subtitle: 'Folge den Anweisungen deines Geräts (Face ID, Touch ID, PIN …).',
  },
};
